// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__BpAjq","header":"ClearentDisclaimer_header__23SQ4","inner":"ClearentDisclaimer_inner__14AY1"};